import { render, staticRenderFns } from "./ListaTitulacao.vue?vue&type=template&id=70df9879"
import script from "./ListaTitulacao.vue?vue&type=script&lang=js"
export * from "./ListaTitulacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports